import {
    LIMITED_STOCK_MESSAGE,
    UPDATE_CART_SUCCESSFULLY,
} from "../../../public/Constants/EnumConstants";
import React, { useTransition } from "react";

import TypographyMontserrat from "../../Atoms/TypographyMontserrat";
import clsx from "clsx";
import { quickAddToCartFromOverlay } from "./constants";
import { sortByVariantSize } from "../../utils/utils";
import { toast } from "react-toastify";

const QuickAddToCartOverlay = ({
    sizeStandard,
    setSelectedVariant,
    setShowVariants,
    selectedVariant,
    variants,
}) => {
    const sortedVariants = sortByVariantSize(variants);
    const [isPending, startTransition] = useTransition();

    return (
        <>
           
            <div className="w-full h-max py-3">
                <TypographyMontserrat
                    align={"left"}
                    customStyle={"uppercase !text-[13px]"}
                    fontWeight="light"
                    text={`Size (${sizeStandard || "UK"}):`}
                />
                <div className="mt-2 flex gap-1 flex-wrap">
                    {sortedVariants?.map((variant, index) => {
                        const sizeOption = variant?.option_values?.find(
                            (option) => option?.option_display_name === "Size"
                        );
                        const selected = selectedVariant?.id === variant?.id;
                        const isAvailableForSale = variant?.inventory_level > 0;
                        return (
                            <div
                                key={index}
                                className={clsx(
                                    "relative flex cursor-pointer font-Poppins justify-center items-center w-10 h-10 border leading-[180%] border-0 text-xs !bg-Ghost_White h-[44px] w-[44px] ",
                                    {
                                        "!bg-selected_pink text-Pink_Rose":
                                            selected && isAvailableForSale,
                                        "ring-1 ring-transparent transition duration-300 ease-in-out ":
                                            !selected && isAvailableForSale,
                                        "cursor-not-allowed overflow-hidden pointer-events-none bg-neutral-100 text-neutral-500 ring-0 ring-neutral-300  before:bg-neutral-300":
                                            !isAvailableForSale,
                                    }
                                )}
                                onClick={() => {
                                    setSelectedVariant(variant);
                                }}
                            >
                                {sizeOption?.label}
                            </div>
                        );
                    })}
                </div>
            </div>
        </>
    );
};

export default QuickAddToCartOverlay;
